import {
  WIDGET_LOCATION_OF_YOUR_KITS,
  WIDGET_LOCATION_OF_YOUR_KITS_RESULT,
  WIDGET_LOCATION_OF_YOUR_KITS_ERROR,
} from './constants';

export const widgetLocationOfYourKitsReducer = (state = {}, action) => {
  switch (action.type) {
    case WIDGET_LOCATION_OF_YOUR_KITS:
      return {
        ...state,
        isLoading: true,
        isError: false,
        data: undefined,
      };
    case WIDGET_LOCATION_OF_YOUR_KITS_RESULT:
      return {
        ...state,
        isLoading: false,
        isError: false,
        data: action.response,
      };

    case WIDGET_LOCATION_OF_YOUR_KITS_ERROR: {
      return {
        ...state,
        isLoading: false,
        isError: true,
        data: undefined,
      };
    }
    default:
      return state;
  }
};
